import dayjs from "dayjs";
import { ISiteV2 } from "../../../interfaces/Site";
import { IDesignTemplate } from "../../../modules/EditDesignTemplate/utils/designTemplates";
import { ISiteModuleText } from "../../../interfaces/ISiteModule";
import { randomId } from "../../../utils/Random";
import { Origin } from "../../../../types/origin";

const generateEmptyModuleForMenu = (menuTitle: string): ISiteModuleText => {
    return {
        siteModuleType: "Text",
        id: "SitePreviewModuleId" + randomId(),
        hide: false,
        hideInMenu: false,
        menuTitle: {
            sv: menuTitle,
        },
        title: {
            contentDataType: "Title",
            text: {
                sv: "",
            },
        },
        text: {
            contentDataType: "RichText",
            richText: {
                sv: "",
            },
        },
    };
};

const content = {
    "wedding": {
        siteTitle: "Emma & Anton",
        location: "Malmö",
        locationTitle: "Vigsel"
    },
    "party": {
        siteTitle: "Saras 40-årsfest",
        location: "Jönköping",
        locationTitle: "18.00 - Middag och fest"
    },
    "event": {
        siteTitle: "Höstkonferens",
        location: "Stockholm",
        locationTitle: "Välkommen till årets höstkonferens!"
    }
}

export const generateSitePreview = (designTemplate: IDesignTemplate) => {
    const dateStart = dayjs().add(6, "M").set("hour", 15).set("minute", 0).format("YYYY-MM-DDTHH:mm");
    const location = content[process.env.REACT_APP_BRAND as Origin].location;
    const locationTitle = content[process.env.REACT_APP_BRAND as Origin].locationTitle;

    const siteTitle = content[process.env.REACT_APP_BRAND as Origin].siteTitle;

    const site: ISiteV2 = {
        theme: designTemplate.theme,
        fonts: {
            heading: designTemplate.fonts.heading,
            text: designTemplate.fonts.text,
        },
        eventLogo: designTemplate.eventLogo,
        siteGraphic: designTemplate.siteGraphic,
        colorScheme: designTemplate.colorScheme,
        customDomainActive: false,
        customDomainActiveDate: null,
        customDomainRegistrationsAvailable: 0,
        metaNoindex: false,
        active: false,
        password: null,
        hasRsvps: false,
        quickStart: true,
        siteVersion: "",
        _id: "START-WIZARD",
        giftRegistryReservations: [],
        availableLanguages: [{ languageCode: "sv" }],
        activeDate: null,
        host: "",
        usesSiteModules: true,
        formRecipients: [],
        siteModules: [
            {
                siteModuleType: "Header",
                id: "SitePreviewModuleId" + randomId(),
                hide: false,
                hideInMenu: false,
                menuTitle: {
                    sv: "Start",
                    en: "Start",
                },
                title: {
                    contentDataType: "Title",
                    text: {
                        sv: siteTitle,
                    },
                },
                secondLine: {
                    contentDataType: "Text",
                    text: {
                        sv: location + " - " + dayjs(dateStart).format("D/M YYYY"),
                    },
                },
                image: {
                    contentDataType: "Image",
                    image: {
                        path: "demo-images/",
                        originalName: `demo_site_${process.env.REACT_APP_BRAND}_header.jpg`,
                        fileName: `demo_site_${process.env.REACT_APP_BRAND}_header.jpg`,
                        temporary: false,
                        isDemoImage: true,
                        sizes: [],
                        width: 1400,
                        height: 788,
                    },
                    userSelectedImageSize: "MEDIUM",
                },
            },
            {
                siteModuleType: "Countdown",
                id: "SitePreviewModuleId" + randomId(),
                hide: false,
                hideInMenu: true,
                menuTitle: {},
                countdownDate: dateStart,
            },
            {
                siteModuleType: "Location",
                id: "SitePreviewModuleId" + randomId(),
                hide: false,
                hideInMenu: false,
                menuTitle: {},
                title: {
                    contentDataType: "Title",
                    text: {
                        sv: locationTitle,
                    },
                },
                map: {
                    contentDataType: "Map",
                    mapTheme: "NORMAL",
                    markerColor: null,
                    zoom: null,
                    map: {
                        size: 640,
                        path: "maps/67a07f56e741b5f7122a2623/640x2_8429fd27110775f04b414d8551c326df43b6ad9065a2f75ae2975e9c178b5e07.png",
                        location: "Nykyrka Kyrka, Mullsjö",
                        sizes: [
                            {
                                size: 640,
                                path: "maps/67a07f56e741b5f7122a2623/640x2_8429fd27110775f04b414d8551c326df43b6ad9065a2f75ae2975e9c178b5e07.png",
                            },
                            {
                                size: 420,
                                path: "maps/67a07f56e741b5f7122a2623/420x2_5f40eb6de0b79a40e1a274e87dafbbe7b509edd517fe533d6c3bfa30a3668c58.png",
                            },
                        ],
                        temporary: false,
                        isDemoImage: true,
                    },
                },
                secondTitle: {
                    contentDataType: "Title",
                    text: {
                        sv: dayjs(dateStart).format("HH:mm") + " - Vigsel i " + location,
                    },
                },
                text: {
                    contentDataType: "RichText",
                    richText: {
                        sv: "<p>Klockan tre börjar vår vigsel i Nykyrka kyrka i Mullsjö. Du hittar smidigast dit genom att följa väg 94 från Åmål ut mot Hägersta, sväng vänster strax innan den stora rondellen där det står skyltat kyrka.</p><p></p><p>Adress: Nykyrkekvarnbacken 2, 123 45, Mullsjö</p>",
                    },
                },
                image: {
                    contentDataType: "Image",
                    image: {
                        path: "demo-images/",
                        originalName: `demo_site_${process.env.REACT_APP_BRAND}_location.jpg`,
                        fileName: `demo_site_${process.env.REACT_APP_BRAND}_location.jpg`,
                        temporary: false,
                        isDemoImage: true,
                        sizes: [],
                        width: 1600,
                        height: 1066,
                    },
                },
            },
            generateEmptyModuleForMenu("Festen"),
            generateEmptyModuleForMenu("Bra att veta"),
            generateEmptyModuleForMenu("Brudfölje"),
            generateEmptyModuleForMenu("Gåvor"),
            generateEmptyModuleForMenu("Tal"),
            generateEmptyModuleForMenu("OSA"),
        ],
    };

    return site;
};
